import _ from 'lodash';
import { IFeedSpread, DataFeedSubscription } from '@tradingblock/types';

/**
 * Creates a DataFeedSubscription array from quotes and/or spreads
 */
export const getFeedSubscription = ({ quotes, spread }: { quotes?: string | string[]; spread?: IFeedSpread }) => {
  let feedValues: DataFeedSubscription[] = [];
  if (quotes) {
    const quoteValues = _.isArray(quotes) ? quotes : [quotes];
    feedValues = [...feedValues, { kind: 'Quote', symbols: quoteValues }];
  }
  if (spread) {
    feedValues = [...feedValues, { kind: 'Spread', spreadDefinition: [spread] }];
  }
  return feedValues;
};

/**
 * Compares two spreads for equality by comparing their structure
 */
export const spreadEquals = (a: IFeedSpread, b: IFeedSpread): boolean => {
  if (!a || !b || !a.Legs || !b.Legs) return false;
  if (a.id !== b.id || a.name !== b.name || a.type !== b.type || a.Legs.length !== b.Legs.length) return false;
  const sortedA = _.sortBy(a.Legs, ['Symbol', 'AssetType']);
  const sortedB = _.sortBy(b.Legs, ['Symbol', 'AssetType']);
  return _.isEqual(sortedA, sortedB);
};

/**
 * Calculates differences between current and subscribed quotes
 */
export const calculateQuoteChanges = (current: string[], subscribed: string[]) => {
  const currentArray = Array.isArray(current) ? current : [];
  const subscribedArray = Array.isArray(subscribed) ? subscribed : [];
  return {
    toAdd: _.uniq(_.difference(currentArray, subscribedArray)),
    toRemove: _.difference(subscribedArray, currentArray),
  };
};

/**
 * Calculates differences between current and subscribed spreads
 */
export const calculateSpreadChanges = (
  current: IFeedSpread[],
  subscribed: IFeedSpread[],
  compareFn: (a: IFeedSpread, b: IFeedSpread) => boolean
) => {
  const currentArray = Array.isArray(current) ? current : [];
  const subscribedArray = Array.isArray(subscribed) ? subscribed : [];
  return {
    toAdd: currentArray.filter(spread => !subscribedArray.some(sub => compareFn(spread, sub))),
    toRemove: subscribedArray.filter(sub => !currentArray.some(spread => compareFn(spread, sub))),
  };
};

